export interface Movie {
  id: string;
  title: string;
  type: "电影" | "电视剧";
  genres: string[];
  region: string;
  year: number;
  updateTime: string;
  rating: number;
  heat: number;
  director: string;
  cast: string[];
  tags: string[];
  cover: string;
  backdrop: string;
  synopsis: string;
}

export const movies: Movie[] = [
  {
    id: "1001",
    title: "暗涌之城",
    type: "电影",
    genres: ["剧情", "犯罪"],
    region: "中国",
    year: 2024,
    updateTime: "2024-11-02",
    rating: 8.6,
    heat: 9820,
    director: "林致远",
    cast: ["沈孤舟", "苏晚棠", "周慕白"],
    tags: ["悬疑", "都市", "人性"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20rainy%20neon%20city%20street%20at%20night%2C%20moody%20deep%20crimson%20and%20gold%20tones%2C%20dramatic%20chiaroscuro%20lighting%2C%20dark%20atmospheric%20background%2C%20film%20noir%20style%2C%20no%20text&width=400&height=600&seq=ymdh-cover-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20a%20rainy%20neon%20city%20street%20at%20night%2C%20moody%20deep%20crimson%20and%20dark%20tones%2C%20atmospheric%20dramatic%20lighting%2C%20detailed%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-01&orientation=landscape",
    synopsis:
      "暴雨夜，一桩看似普通的失窃案牵出城市地下暗涌多年的利益网络。退休刑警沈孤舟本想安静度日，却因一封匿名信重回案发现场。随着调查深入，他发现当年的旧案与如今的新案彼此缠绕，而真正操纵这一切的人，恰恰藏在他最信任的人身边。真相浮出水面的那一刻，整座城市都为之震颤。",
  },
  {
    id: "1002",
    title: "诱惑秘境",
    type: "电影",
    genres: ["爱情", "剧情"],
    region: "韩国",
    year: 2024,
    updateTime: "2024-10-21",
    rating: 8.1,
    heat: 8760,
    director: "姜秀雅",
    cast: ["徐智恩", "韩泽宇", "朴恩珠"],
    tags: ["情感", "悬念", "女性"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20an%20elegant%20woman%20silhouette%20in%20soft%20red%20light%2C%20moody%20deep%20crimson%20and%20gold%20tones%2C%20dramatic%20atmospheric%20lighting%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20an%20elegant%20woman%20silhouette%20in%20soft%20red%20light%2C%20moody%20deep%20crimson%20and%20dark%20tones%2C%20atmospheric%20lighting%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-02&orientation=landscape",
    synopsis:
      "一封寄错地址的邀请函，将美术馆策展人徐智恩带进一座与世隔绝的庄园。庄园主人以近乎执拗的方式收藏着世间稀有的美，而这份美背后，是层层叠加的秘密与被掩埋的过往。智恩在探索庄园的过程中，逐渐发现自己与这座庄园之间存在着一段无法割舍的渊源。",
  },
  {
    id: "1003",
    title: "岳母的诱惑 第一季",
    type: "电视剧",
    genres: ["都市", "情感"],
    region: "中国",
    year: 2025,
    updateTime: "2025-01-08",
    rating: 8.9,
    heat: 15420,
    director: "陈立凡",
    cast: ["顾清和", "白若薇", "陆知远"],
    tags: ["家庭", "情感", "悬念"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20modern%20luxury%20living%20room%20with%20warm%20red%20and%20gold%20lighting%2C%20moody%20dramatic%20atmosphere%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20a%20modern%20luxury%20living%20room%20with%20warm%20red%20and%20gold%20lighting%2C%20moody%20dark%20atmosphere%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-03&orientation=landscape",
    synopsis:
      "新郎陆知远迎娶白若薇的当天，才发现岳母顾清和远比想象中难以相处。这位优雅而强势的长辈对这个新女婿百般挑剔，家里的每一次家宴都暗藏交锋。随着一桩多年前的往事被重新翻出，这段看似普通的姻亲关系背后，竟牵连着两个家族长久以来未曾言明的秘密。",
  },
  {
    id: "1004",
    title: "血色黄昏",
    type: "电影",
    genres: ["剧情", "悬疑"],
    region: "欧美",
    year: 2023,
    updateTime: "2023-09-14",
    rating: 7.8,
    heat: 7120,
    director: "Marcus Vale",
    cast: ["Elena Ross", "Thomas Grey", "Nadia Klein"],
    tags: ["公路", "复仇", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20lone%20road%20at%20blood%20red%20sunset%2C%20moody%20deep%20crimson%20and%20gold%20tones%2C%20dramatic%20lighting%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20a%20lone%20road%20at%20blood%20red%20sunset%2C%20moody%20deep%20crimson%20and%20dark%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-04&orientation=landscape",
    synopsis:
      "一场突如其来的车祸，让旅行者Elena被迫停在荒漠小镇。小镇的人们热情得有些反常，每个人似乎都在隐瞒着什么。当黄昏再次降临，Elena发现离开这里的唯一道路，指向的是一个她从未预料到的真相。",
  },
  {
    id: "1005",
    title: "冬日回声",
    type: "电视剧",
    genres: ["爱情", "剧情"],
    region: "日本",
    year: 2024,
    updateTime: "2024-03-27",
    rating: 8.3,
    heat: 6890,
    director: "中村涼子",
    cast: ["藤井葵", "佐仓凛", "大野结衣"],
    tags: ["治愈", "慢生活", "纯爱"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20snowy%20quiet%20town%20in%20warm%20dusk%20light%2C%20moody%20deep%20red%20and%20gold%20tones%2C%20dramatic%20atmospheric%20lighting%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20a%20snowy%20quiet%20town%20in%20warm%20dusk%20light%2C%20moody%20deep%20red%20and%20dark%20tones%2C%20atmospheric%20lighting%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-05&orientation=landscape",
    synopsis:
      "因为一封没有寄出的信，藤井葵回到了阔别七年的北方小镇。大雪覆盖了街道，也覆盖了那些未说出口的话。在旧咖啡店里，她重新遇见了少年时代的那个人，而这一次，她决定不再沉默。",
  },
  {
    id: "1006",
    title: "金色牢笼",
    type: "电影",
    genres: ["悬疑", "惊悚"],
    region: "欧美",
    year: 2022,
    updateTime: "2022-12-05",
    rating: 7.6,
    heat: 5940,
    director: "Clara Bennett",
    cast: ["Sophie Lang", "Daniel Cross", "Marie Vaugh"],
    tags: ["心理", "密室", "反转"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20golden%20birdcage%20in%20a%20dark%20room%2C%20moody%20deep%20crimson%20and%20gold%20tones%2C%20dramatic%20lighting%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20a%20golden%20birdcage%20in%20a%20dark%20room%2C%20moody%20deep%20crimson%20and%20dark%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-06&orientation=landscape",
    synopsis:
      "被高薪聘请进入神秘别墅的看护Sophie，很快发现雇主一家对外的优雅只是表象。这座金碧辉煌的宅邸，每一扇窗都上了锁，每一个微笑都经过计算。当她试图离开时，才明白自己早已成为笼中那只最昂贵的鸟。",
  },
  {
    id: "1007",
    title: "城南旧事新编",
    type: "电视剧",
    genres: ["家庭", "剧情"],
    region: "中国",
    year: 2023,
    updateTime: "2023-06-18",
    rating: 8.0,
    heat: 6320,
    director: "许静山",
    cast: ["何秀兰", "程亦舟", "林小满"],
    tags: ["年代", "亲情", "回忆"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20old%20town%20alley%20at%20night%20with%20warm%20lantern%20light%2C%20moody%20deep%20red%20and%20gold%20tones%2C%20dramatic%20atmosphere%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20an%20old%20town%20alley%20at%20night%20with%20warm%20lantern%20light%2C%20moody%20deep%20red%20and%20dark%20tones%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-07&orientation=landscape",
    synopsis:
      "老城南的巷子里，经营了三十年的旧茶馆即将拆迁。老板娘何秀兰与归乡的儿子程亦舟，不得不重新面对多年未曾提起的心结。邻里间的家长里短、岁月里的聚散离合，都在这条即将消失的巷子里缓缓铺开。",
  },
  {
    id: "1008",
    title: "夜航西飞",
    type: "电影",
    genres: ["剧情", "冒险"],
    region: "中国",
    year: 2021,
    updateTime: "2021-08-30",
    rating: 7.9,
    heat: 5230,
    director: "罗砚",
    cast: ["江予怀", "秦远道", "叶青禾"],
    tags: ["公路", "梦想", "治愈"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20an%20airplane%20wing%20over%20a%20dark%20desert%20at%20dusk%2C%20moody%20deep%20crimson%20and%20gold%20tones%2C%20dramatic%20lighting%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20an%20airplane%20wing%20over%20a%20dark%20desert%20at%20dusk%2C%20moody%20deep%20crimson%20and%20dark%20tones%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-08&orientation=landscape",
    synopsis:
      "退役飞行员江予怀答应帮老朋友完成最后一次夜航，把一架老式飞机送到千里之外的机场。途中突遇气流，两人迫降在无人的戈壁。在等待救援的两天里，他们聊起了一生的遗憾与未曾实现的心愿。",
  },
  {
    id: "1009",
    title: "温柔的陷阱",
    type: "电视剧",
    genres: ["爱情", "都市"],
    region: "韩国",
    year: 2025,
    updateTime: "2025-02-11",
    rating: 8.4,
    heat: 11280,
    director: "李准浩",
    cast: ["郑雅琳", "尹世勋", "车银菲"],
    tags: ["爱恨", "职场", "悬念"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20rose%20in%20dim%20red%20light%2C%20moody%20deep%20crimson%20and%20gold%20tones%2C%20dramatic%20atmosphere%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20a%20rose%20in%20dim%20red%20light%2C%20moody%20deep%20crimson%20and%20dark%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-09&orientation=landscape",
    synopsis:
      "职场精英郑雅琳遇见了完美得无可挑剔的尹世勋。浪漫的相遇、恰到好处的体贴，一切都像童话。可越是靠近，雅琳越感到不安——这场爱情像被精心设计过，每一个细节都像是有人提前写好的剧本。",
  },
  {
    id: "1010",
    title: "无声告白",
    type: "电影",
    genres: ["悬疑", "剧情"],
    region: "中国",
    year: 2024,
    updateTime: "2024-05-19",
    rating: 8.2,
    heat: 8460,
    director: "韩沐",
    cast: ["温言", "傅清让", "罗静姝"],
    tags: ["校园", "真相", "人性"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20an%20empty%20classroom%20with%20a%20red%20shadow%2C%20moody%20deep%20crimson%20and%20gold%20tones%2C%20dramatic%20lighting%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20an%20empty%20classroom%20with%20a%20red%20shadow%2C%20moody%20deep%20crimson%20and%20dark%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-10&orientation=landscape",
    synopsis:
      "十年前的一桩校园旧事，被一张重新出现的照片打破沉默。当年所有人都选择了“不知道”，如今当年的当事人却接连收到匿名信。真相并不复杂，复杂的是人们宁愿相信的那个版本。",
  },
  {
    id: "1011",
    title: "曼谷雨季",
    type: "电视剧",
    genres: ["爱情", "剧情"],
    region: "泰国",
    year: 2022,
    updateTime: "2022-07-22",
    rating: 7.7,
    heat: 4880,
    director: "Napat S.",
    cast: ["Pim Chan", "Anan T.", "Rin K."],
    tags: ["异国", "成长", "错过"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20rainy%20tropical%20alley%20in%20warm%20night%20light%2C%20moody%20deep%20red%20and%20gold%20tones%2C%20dramatic%20atmosphere%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20a%20rainy%20tropical%20alley%20in%20warm%20night%20light%2C%20moody%20deep%20red%20and%20dark%20tones%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-11&orientation=landscape",
    synopsis:
      "背井离乡来到曼谷打拼的Pim，在雨季最潮湿的日子遇见了同样迷茫的Anan。两个在异国漂泊的年轻人，用一场又一场的雨季陪伴彼此，也在离别到来时学会了放手与成长。",
  },
  {
    id: "1012",
    title: "逆流而上",
    type: "电影",
    genres: ["励志", "剧情"],
    region: "中国",
    year: 2020,
    updateTime: "2020-10-16",
    rating: 7.5,
    heat: 4120,
    director: "岳南川",
    cast: ["方知夏", "谢沉", "杜若衡"],
    tags: ["热血", "竞技", "成长"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20swimmer%20in%20dark%20water%20with%20golden%20light%2C%20moody%20deep%20crimson%20and%20gold%20tones%2C%20dramatic%20lighting%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20a%20swimmer%20in%20dark%20water%20with%20golden%20light%2C%20moody%20deep%20crimson%20and%20dark%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-12&orientation=landscape",
    synopsis:
      "因伤退役的游泳运动员方知夏回到家乡，成了一名普通少年队教练。面对一群不服管教的“问题少年”，她用最笨拙也最真诚的方式，带着他们一步一步游向那个所有人都不曾相信的终点。",
  },
  {
    id: "1013",
    title: "镜中人",
    type: "电影",
    genres: ["惊悚", "悬疑"],
    region: "欧美",
    year: 2023,
    updateTime: "2023-11-11",
    rating: 7.4,
    heat: 5560,
    director: "Nolan Reed",
    cast: ["Grace Moore", "Peter Hale", "Luna Diaz"],
    tags: ["心理", "反转", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20cracked%20mirror%20in%20a%20dark%20red%20room%2C%20moody%20deep%20crimson%20and%20gold%20tones%2C%20dramatic%20lighting%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20a%20cracked%20mirror%20in%20a%20dark%20red%20room%2C%20moody%20deep%20crimson%20and%20dark%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-13&orientation=landscape",
    synopsis:
      "搬进老房子的Grace发现，镜子里的自己似乎总比现实中慢上半秒。起初她以为是错觉，直到某天深夜，镜中的“她”做出了一个她从未做过的动作。",
  },
  {
    id: "1014",
    title: "海街日记簿",
    type: "电视剧",
    genres: ["生活", "治愈"],
    region: "日本",
    year: 2021,
    updateTime: "2021-05-09",
    rating: 8.5,
    heat: 6010,
    director: "浜田静",
    cast: ["宫下遥", "白石桃", "长谷川枫"],
    tags: ["治愈", "日常", "亲情"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20seaside%20town%20at%20warm%20sunset%2C%20moody%20deep%20red%20and%20gold%20tones%2C%20dramatic%20atmospheric%20lighting%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20a%20seaside%20town%20at%20warm%20sunset%2C%20moody%20deep%20red%20and%20dark%20tones%2C%20atmospheric%20lighting%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-14&orientation=landscape",
    synopsis:
      "海边小镇上的三姐妹，在父亲去世后重新聚到了一起。她们各自带着不为人知的疲惫，却在每日的早餐、潮声与寻常对话里，慢慢找回了继续生活的勇气。",
  },
  {
    id: "1015",
    title: "燃烧的青春",
    type: "电影",
    genres: ["喜剧", "青春"],
    region: "中国",
    year: 2022,
    updateTime: "2022-04-01",
    rating: 7.2,
    heat: 3980,
    director: "池野",
    cast: ["夏一舟", "米乐", "宋知遥"],
    tags: ["校园", "热血", "友情"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20fireworks%20over%20a%20rooftop%20at%20night%2C%20moody%20deep%20crimson%20and%20gold%20tones%2C%20dramatic%20lighting%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20fireworks%20over%20a%20rooftop%20at%20night%2C%20moody%20deep%20crimson%20and%20dark%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-15&orientation=landscape",
    synopsis:
      "为了凑齐毕业晚会的经费，五个性格迥异的高中生组成了一个荒唐的临时乐队。排练一塌糊涂，麻烦接踵而来，可正是这段鸡飞狗跳的日子，成了他们日后最想回去的夏天。",
  },
  {
    id: "1016",
    title: "沉睡的森林",
    type: "电视剧",
    genres: ["悬疑", "犯罪"],
    region: "欧美",
    year: 2024,
    updateTime: "2024-09-03",
    rating: 8.7,
    heat: 10340,
    director: "Ingrid Holm",
    cast: ["Ada Frost", "Jonas Berg", "Mira Lund"],
    tags: ["犯罪", "推理", "悬念"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20dark%20foggy%20forest%20with%20faint%20light%2C%20moody%20deep%20red%20and%20gold%20tones%2C%20dramatic%20atmosphere%2C%20dark%20background%2C%20no%20text&width=400&height=600&seq=ymdh-cover-16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20wide%20shot%20of%20a%20dark%20foggy%20forest%20with%20faint%20light%2C%20moody%20deep%20crimson%20and%20dark%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=1280&height=720&seq=ymdh-bg-16&orientation=landscape",
    synopsis:
      "北境小镇的森林里，一名少女在失踪七年后被发现安然沉睡于林间。她记得自己是谁，却对这段时间毫无记忆。警探Ada Frost接手此案，越查越发现，整座小镇似乎都在这场沉睡里，共享着同一个不愿醒来的秘密。",
  },
];